import Updates from './Updates';

export default Updates;
